<template>
  <div>

    <div class="top">
      <div class="title">商品数据统计 </div>
      <div class="flex">
        <!-- 1平台邀请人数 -->
        <div class="topPage" v-for="(item,index) in topList" :key="index">
          <div class="card_page">
            <div class="info pointer" @click="openPage(item.page,item.params,item.paramsVal)">
              <div class="title"> {{item.title}}</div>
              <div class="number"> {{item.number}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商品成交统计 -->
    <div class="top conter">
      <div class="title">商品数据统计 </div>
      <div id="corver"></div>
    </div>
    <div class="conter">
      <Card dis-hover>

        <div class="query">
          <Divider orientation="left" style="position: relative;top: -12px;">查询条件
          </Divider>
          <Form :model="queryForm" ref="queryForm" label-position="right" :label-width="90" inline>

            <FormItem prop="name" label="交易统计">
              <Select v-model="queryForm.orderYear" style="width:185px;">
                <Option value="">--</Option>
                <Option value="2018">2018年</Option>
                <Option value="2019">2019年</Option>
              </Select>
            </FormItem>
            <FormItem class="button function">
              <Button type="primary" @click="getData()" icon="md-search">查询</Button>
            </FormItem>
          </Form>
        </div>
        <div class="table_btn">
          <div class="button tab_btn">
            <cols-show @changeShowColumns="changeShowColumns" :columns="columns"> </cols-show>
            <Button @click="exportData()" icon="md-arrow-down" title='导出'></Button>
            <Button @click="printTable()" icon="ios-print" title='打印'></Button>
          </div>
          <div class="tab_a" id="printDiv">
            <Table border stripe :loading="loading" ref="selection" no-data-text="暂无数据" :columns="showColumns" :data="data">

            </Table>
          </div>

        </div>
      </Card>
    </div>

    <!-- 打印 -->
    <simple-table ref="checkTable" :columns="showColumns" :data="data" title="首页用户支付信息" :sub-title="$moment().format('yyyy-MM-DD HH:mm:ss')" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      queryForm: {
        orderYear:'',
      }, //查询参数
      topList: [
        {
          title: '待发货',
          number: 0,
          page: 'orderForm',
          params: 'state',
          paramsVal: this.$orderForm.待发货,
        },
        {
          title: '待处理退款申请',
          number: 0,
          page: 'orderForm',
          params: 'orderState',
          paramsVal: this.$orderForm.申请退款,
        },
        {
          title: '已支付订单',
          number: 0,
          page: 'orderForm',
          params: 'orderState',
          paramsVal: this.$orderForm.支付完成,
        },
        {
          title: '待付款',
          number: 0,
          page: 'orderForm',
          params: 'orderState',
          paramsVal: this.$orderForm.等待支付,
        },
        {
          title: '商品数量（个）',
          number: 0,
          page: 'commodity',
          params: '',
          paramsVal: '',
        },
        {
          title: '出售中商品（个）',
          number: 0,
          page: 'commodity',
          params: 'state',
          paramsVal: this.$commodity.出售中,
        },
        {
          title: '下架商品（个）',
          number: 0,
          page: 'commodity',
          params: 'state',
          paramsVal: this.$commodity.已下架,
        },
        {
          title: '预警库存商品（个）',
          number: 0,
          page: 'specification',
          params: 'state',
          paramsVal: this.$specification.库存预警,
        },
      ],
      showColumns: [],
      columns: [
        {
          title: '时间',
          key: 'orderMonth',
          tooltip: true,
        },
        {
          title: '下单数',
          key: 'orderCount',
          tooltip: true,
        },
        {
          title: '支付订单数',
          key: 'orderPayCount',
          tooltip: true,
        },
        {
          title: '支付积分',
          key: 'orderPointPay',
          tooltip: true,
        },
      ],
      data: [],
    }
  },
  mounted() {
    this.getInit()
  },

  methods: {
    //   获取信息
    async getInit() {
      this.loading = true

      let { data } = await this.$Ajax.get(`/api/services/app/GetIndexService/HomeIndex`)
      let allData = data.result.indexModel_GYS

      this.topList.map((el) => {
        if (el.title == '待发货') {
          el.number=allData.unDeliveryCount
        }
         if (el.title == '待处理退款申请') {
          el.number=allData.unHandleCount
        }
         if (el.title == '已支付订单') {
          el.number=allData.alreadyPayCount
        }
         if (el.title == '待付款') {
          el.number=allData.unPayCount
        }
         if (el.title == '商品数量（个）') {
          el.number=allData.productCount
        }
         if (el.title == '出售中商品（个）') {
          el.number=allData.onSaleProductCount
        }
         if (el.title == '下架商品（个）') {
          el.number=allData.offShelfProductCount
        }
         if (el.title == '预警库存商品（个）') {
          el.number=allData.inventoryAlertProductCount
        }
      })
      var chart = Highcharts.chart('corver', {
        chart: {
          type: 'areaspline', //column
        },
        title: {
          text: '月交易量统计',
        },
        subtitle: {
          text: '数据来源: 益杏健康',
        },
        xAxis: {
        
          categories: allData.monthList,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: '交易量',
          },
        },
        tooltip: {
          // head + 每个 point + footer 拼接成完整的 table
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
        },
        series: [
          {
            name: '下单数',
            data: allData.orderCountList,
          },
          {
            name: '支付订单数',
            data: allData.orderPayCountList,
          },
          {
            name: '退单数',
            data: allData.orderReturnCountList,
          },
          // {
          //   name: '支付积分',
          //   data: [4204, 3302, 3405, 3907, 5206, 7505, 5704, 6004, 4706, 3901, 4608, 5101],
          // },
        ],
      })
      this.getData()
      this.loading = false
    },
    //显示列
    changeShowColumns(cols) {
      console.log('🚀 ~ file: gysHome.vue:263 ~ changeShowColumns ~ cols:', cols)
      this.showColumns = cols
    },
    // 打开页面
    openPage(name, paramsName, paramsValue) {
      this.$router.push({
        name: name,
        params: { paramsName, paramsValue },
      })
    },
    async getData() {
      this.loading = true
      let { data } = await this.$Ajax.get('/api/services/app/UserExchangeService/GetUserExchangeData', {
        params:this.queryForm,
      })
      this.data = data.result
      this.loading = false
    },
    //打印
    printTable() {
      // 执行打印方法
      this.$refs['checkTable'].printTable()
    },

    //导出已选数据
    exportData() {
      this.$excelExport(this.columns.slice(0, this.columns.length - 1), this.data)
    },
  },
}
</script>

<style scoped media="screen" lang="less">
.top {
  background: #fff;
  box-shadow: 0 0 17px 0 rgba(130, 122, 122, 0.1);
  border-radius: 8px;
  justify-content: space-between;
  transition: all 0.2s ease-in-out;

  > .title {
    border-bottom: 1px solid #eee;
    padding: 10px;
  }
  .flex {
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px;
    .info {
      .title {
        font-size: 22px;
      }
      .number {
        font-size: 16px;
        color: cornflowerblue;
      }
    }
  }
}
.pointer {
  cursor: pointer;
}
.hover {
  border-radius: 5px;
  padding: 2px 2px;
}
.hover:hover {
  border: 2px solid #49505742;
}
.topPage {
  //   width: 24%;
  margin-top: 10px;
}
.card_page {
  font-size: 14px;
  min-height: 80px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.conter {
  margin-top: 20px;
}
/deep/.ivu-modal-footer {
  display: none;
}
.noAuto {
  text-align: center;
  color: #b9b9b9;
}
.role {
  .ivu-switch {
    margin-right: 10px;
  }
}
.table_btn {
  margin-top: 10px;
}
.tab_a {
  position: relative;
}
.totalPayPiont {
  position: absolute;
  top: -28px;
  font-size: 15px;
  span {
    color: #57a3f3;
    font-size: 19px;
  }
}
.ivu-divider-horizontal.ivu-divider-with-text-left,
.ivu-divider-horizontal.ivu-divider-with-text-right {
  font-size: 16px;
  color: #57a3f3;
}
.page_btn {
  display: flex;
}
.page_button {
  margin-top: 20px;
  button {
    margin-right: 10px;
  }
}
.divi {
  cursor: pointer;
}
.tab_btn {
  display: flex;
  justify-content: right;
  margin-bottom: 5px;
}

.button {
  * {
    margin-right: 10px;
  }
}

.function /deep/.ivu-form-item-content {
  margin-left: 10px !important;
}
@media screen and (max-width: 100800px) {
  .topPage {
    width: 24%;
  }
  .contentPage:nth-of-type(1) {
    width: 63.5%;
  }
  .contentPage:nth-of-type(2) {
    width: 35%;
  }
  .bottomPage:nth-of-type(1) {
    width: 35%;
  }
  .bottomPage:nth-of-type(2) {
    width: 63.5%;
  }
}
@media screen and (max-width: 1550px) {
  .topPage {
    width: 48%;
  }
  .contentPage:nth-of-type(1) {
    width: 63.5%;
  }
  .contentPage:nth-of-type(2) {
    width: 35%;
  }
  .bottomPage:nth-of-type(1) {
    width: 35%;
  }
  .bottomPage:nth-of-type(2) {
    width: 63.5%;
  }
}
@media screen and (max-width: 1350px) {
  .topPage {
    width: 48%;
  }
  .contentPage:nth-of-type(1) {
    width: 100%;
  }
  .contentPage:nth-of-type(2) {
    width: 100%;
  }
  .bottomPage:nth-of-type(1) {
    width: 100%;
  }
  .bottomPage:nth-of-type(2) {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  .topPage {
    width: 100%;
  }
  .contentPage:nth-of-type(1) {
    width: 100%;
  }
  .contentPage:nth-of-type(2) {
    width: 100%;
  }
  .bottomPage:nth-of-type(1) {
    width: 100%;
  }
  .bottomPage:nth-of-type(2) {
    width: 100%;
  }
}
</style>
